import { useContext } from 'react';
import LoadingVehicleCarousel from '@/common/VehicleCarousel/LoadingVehicleCarousel';
import SectionWrapper from '@/home/common/SectionWrapper';
import GlobalContext from '~/context/home/GlobalContext';
import getTopCarouselsLayout from '~/utilities/home/getTopCarouselsLayout';
import RecentlyViewed from './RecentlyViewed';
import SuggestedForYou from './SuggestedForYou';

export default function TopCarousels() {
  const { vdpCardTypeShown, isVdpLinksLoaded } = useContext(GlobalContext);
  const { isSuggestedFirst } = getTopCarouselsLayout(vdpCardTypeShown);

  if (!isVdpLinksLoaded) {
    return (
      <SectionWrapper analyticsSection={'Top Carousels'}>
        <LoadingVehicleCarousel hasBottomBorder />
        <LoadingVehicleCarousel />
      </SectionWrapper>
    );
  }

  return (
    <>
      {isSuggestedFirst ? (
        <>
          <SuggestedForYou />
          <RecentlyViewed />
        </>
      ) : (
        <>
          <RecentlyViewed />
          <SuggestedForYou />
        </>
      )}
    </>
  );
}
